import React, { Component } from 'react';
import './TutorialIndex.css';
import TutorialIndexSummary from '../TutorialModel/TutorialIndexSummary';

export  default class TutorialIndex extends Component
{
  constructor(props)
  {
    super(props);
    this.state={
      TutorialIndexes: this.props.TutorialIndexes || [],
      isLoading: true,
      error: null
    }
  }

  async componentDidMount(prevProps) {
    
      this.setState({
        TutorialIndexes: this.props.TutorialIndexes 
      });
    
  }

  render()
  {
    let TutorialIndexes=this.state.TutorialIndexes;

       if(TutorialIndexes==null || TutorialIndexes==undefined)
        {
          return (

            <aside className="tutorial-index">
               <h2>Loding</h2>
            </aside>
          )

        }

        return(  
        <aside className="tutorial-index">
          <h2>Contents</h2>
          <ul>
          {
            TutorialIndexes.map((item,index)=>
              (
              <li key={index}><a href={item.LinkToSection}>{item.IndexName}</a></li>
              ))
          }
          </ul>
       
        </aside>);

  }
}
